// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1NNig","label":"SetPasswdForm_label__1mnoH"};